import type { ColTypeDef } from 'ag-grid-community'
import { type ColDef } from '@ag-grid-community/core'
import type { CellDataTypes, TableRowData } from '../types/data'
import { generateSafeId } from '../utils/data'
export type ColDefWithID = ColDef<TableRowData> & {
  colId: string
  cellDataType: CellDataTypes
  type?: string | string[]
}

export type ColumnsBaseType = 'base' | 'template' | 'selection' | 'controller'

type DefaultColumns = [string, CellDataTypes]

export type ColumnTypeDefinition = Record<
  ColumnsBaseType,
  ColTypeDef<TableRowData>
>
export function createDefaultColumns(columnsNames?: string[]): ColDefWithID[] {
  const columns: DefaultColumns[] = []
  if (columnsNames) {
    for (let i = 0; i < columnsNames.length; i++)
      columns.push([columnsNames[i], 'text'])
  }
  else {
    for (let i = 0; i < 7; i++) columns.push([`New Column ${i + 1}`, 'text'])
  }

  const data = columns.map(([headerName, cellDataType]) =>
    columnFactory('base', { headerName, cellDataType }),
  )
  return data
}

export function columnFactory(
  columnType: ColumnsBaseType[] | ColumnsBaseType,
  extraData: Partial<ColDefWithID>,
): ColDefWithID {
  const id = generateSafeId()
  const data: ColDef<TableRowData> = {
    sortable: true,
    filter: true,
    editable: true,
    colId: id,
    field: id,
    resizable: true,
    cellDataType: 'html',
    type: columnType,
    headerName: id,
    suppressHeaderKeyboardEvent: (_) => {
      return true
    },
    suppressKeyboardEvent: (params) => {
      if (params.event.key === 'Backspace' || params.event.key === 'Delete')
        return true

      return false
    },
  }

  return { ...data, ...extraData } as ColDefWithID
}

export const BaseColumns: ColDefWithID[] = [
  {
    colId: 'selection',
    checkboxSelection: false,
    // headerCheckboxSelection: true,
    headerCheckboxSelectionFilteredOnly: true,
    type: 'selection',
    editable: false,
    lockPosition: true,
    pinned: 'left',
    cellDataType: 'text',
    lockVisible: true,
    suppressNavigable: true,
    suppressColumnsToolPanel: true,
    suppressFiltersToolPanel: true,
    suppressHeaderFilterButton: true,
    suppressPaste: true,
  },
  {
    colId: 'columnController',
    type: 'controller',
    cellDataType: 'text',
    suppressColumnsToolPanel: true,
    suppressFiltersToolPanel: true,
    suppressHeaderFilterButton: true,
    suppressPaste: true,
  },
  {
    colId: 'id',
    field: 'id',
    hide: true,
    suppressColumnsToolPanel: true,
    suppressFiltersToolPanel: true,
    suppressHeaderFilterButton: true,
    type: 'base',
    cellDataType: 'text',
    suppressPaste: true,
  },
]
